import { ArrowRight } from "lucide-react";

/**
 * An old value struck through, an arrow, and the new value. Cut, the pair
 * stays on one line and each value ellipsizes on its own, so a long old value
 * cannot hide the new one. Wrapped, both values show in full.
 * @param from - The old value
 * @param to - The new value
 * @param wrap - Whether the values wrap instead of being cut
 */
export const ItemHistoryChangeValues = ({
  from,
  to,
  wrap = false,
}: {
  from: string;
  to: string;
  wrap?: boolean;
}) => {
  if (wrap) {
    return (
      <span className="[overflow-wrap:anywhere]">
        <span className="text-muted-foreground line-through">{from}</span>{" "}
        <ArrowRight
          aria-hidden
          className="inline h-3 w-3 align-[-1px] text-muted-foreground"
        />{" "}
        <span className="font-medium">{to}</span>
      </span>
    );
  }
  return (
    <span className="flex min-w-0 items-baseline justify-end gap-1">
      <span className="max-w-[45%] shrink-0 truncate text-muted-foreground line-through">
        {from}
      </span>
      <ArrowRight
        aria-hidden
        className="relative top-px h-3 w-3 shrink-0 text-muted-foreground"
      />
      <span className="min-w-0 truncate font-medium">{to}</span>
    </span>
  );
};
